<template>
    <div id="past-transaction" class="details-head details-section">
        <div class="details-soft-text pb-4 text-capitalize">Past Transaction in {{ project }}</div>
        <div v-if="isloaded" class="position-relative">
            <swiper class="swiper swiper-pt" :options="swiperOption">
                <swiper-slide class="details-highlights-card border-b pb-4">
                    <div class="general-heading-1 text-capitalize">1-storey Detached Factory at Kawasan Perindusrian RIngan IKS Simpang Ampat</div>
                    <div class="details-loc py-3">Transacted at 20 Jan 2020</div>
                    <div class="d-flex align-items-center">
                        <div>
                            <div class="details-price">SOLD AT RM 1,200,000</div>
                            <div class="d-flex"><div class="details-hashtags mx-0">753 Sqft RM 332/sqft</div></div>
                        </div>
                        <!-- <div style="min-width:50px;margin-left:auto;">
                            <div style="height:50px;width:50px;background:gray;border-radius:50%;">Property image</div>
                        </div> -->
                    </div>
                </swiper-slide>
                <swiper-slide class="details-highlights-card border-b pb-4">
                    <div class="general-heading-1 text-capitalize">1-storey Detached Factory at Kawasan Perindusrian RIngan IKS Simpang Ampat</div>
                    <div class="details-loc py-3">Transacted at 20 Jan 2020</div>
                    <div class="d-flex align-items-center">
                        <div>
                            <div class="details-price">SOLD AT RM 1,200,000</div>
                            <div class="d-flex"><div class="details-hashtags mx-0">753 Sqft RM 332/sqft</div></div>
                        </div>
                        <!-- <div style="min-width:50px;margin-left:auto;">
                            <div style="height:50px;width:50px;background:gray;border-radius:50%;">Property image</div>
                        </div> -->
                    </div>
                </swiper-slide>
                <div class="swiper-button-prev" slot="button-prev">Prev</div>
                <div class="swiper-button-next" slot="button-next">Next</div>
            </swiper>
        </div>
    </div>
</template>

<script>
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'

    export default {
        name: "prop-highlight",
        props: ['project'],
        components: {
            Swiper,
            SwiperSlide
        },
        data() {
            return {
                isloaded: true,
                swiperOption: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }
                },
            }
        },
        methods: {
            addComma: function (num) {
                if (num != null) {
                    var num_parts = num.toString().split(".");
                    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    return num_parts.join(".");
                } else { return ''; }
			},
        }

    };
</script>

<style scoped>
    .swiper-pt {
        padding-bottom: 40px;
    }

    .swiper-button-next, .swiper-button-prev {
        color: #AFAFAF !important;
        background: none;
        height: 30px;
        width: 30px;
        top: auto !important;
        bottom: 0;
        border: none;
        border-radius: 50%;
    }

    .swiper-button-next:after, .swiper-button-prev:after {
        font-size: 14px !important;
        display: none;
    }

    .swiper, .swiper-wrapper, .details-highlights-card {
        z-index: 0 !important;
    }

</style>